(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Handle hash scrolling
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Auto-apply "In stock" filter on collection pages
  if (!window.location.search.includes('filter.v.availability')) {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('filter.v.availability', '1');
    window.location.href = newUrl.toString();
  }

  } catch(e) { console.error(e); }
})();
})();
